import React, { useEffect, useState } from "react";
import SinglePdfImage from "./SinglePdfImage";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import { connect } from "react-redux";
import {
  getMasterPdfTemplateListAction,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  resetPdfTemplate,
} from "../../../../redux/masterData";
import {
  createMappedPdfTemplateAction,
  getMappedPdfTemplateAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMappedPdfTemplate,
  resetMessage,
} from "../../../../redux/clientSettings";
import {
  GetMasterDataListPayloadType,
  PdfTemplatesType,
  PdfTemplateType,
} from "../../../../commonTypes/masterDataTypes";
import { ErrorSuccessModal, Loader } from "../../../commons";
import { useParams } from "react-router-dom";
import GeneralSettingPdfPreviewModal from "./GeneralSettingPdfPreviewModal";
import {
  AddPdfMappingTemplatePayloadType,
  GetPdfMappingTemplatePayloadType,
  PdfTemplateMappingsType,
  PdfTemplateMappingType,
  PdfTemplateOptionsType,
  PdfTemplateOptionType,
} from "../../../../commonTypes/clientSettingsTypes";
import toast, { Toaster } from "react-hot-toast";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";

type AppProps = {
  history: any;
  token: string | null;
  masterFetching: boolean;
  masterStatusCode: null | number;
  masterError: null | string;
  masterSuccess: null | number;
  masterMessage: string | null;
  menuName: string;
  success: null | number;
  fetching: boolean;
  error: null | string;
  statusCode: null | number;
  message: string | null;
  dispatchResetSession: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetMappedPdfTemplateAction: () => void;
  pdfTemplateList: PdfTemplatesType | [];
  pdfTemplateCount: number;
  mappedPdfTemplate: PdfTemplateMappingsType | [];
  dispatchGetMasterPdfTemplateAction: (
    data: GetMasterDataListPayloadType
  ) => void;
  dispatchGetMappedPdfTemplateAction: (
    data: GetPdfMappingTemplatePayloadType
  ) => void;
  dispatchCreateMappedPdfTemplateAction: (
    data: AddPdfMappingTemplatePayloadType
  ) => void;
  dispatchResetMasterPdfTemplateList: () => void;
};

const PdfTemplates = ({
  history,
  token,
  masterFetching,
  masterStatusCode,
  masterError,
  masterSuccess,
  masterMessage,
  success,
  fetching,
  error,
  statusCode,
  message,
  menuName,
  pdfTemplateList,
  pdfTemplateCount,
  mappedPdfTemplate,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingMessage,
  dispatchResetClientSettingsError,
  dispatchGetMasterPdfTemplateAction,
  dispatchGetMappedPdfTemplateAction,
  dispatchResetMappedPdfTemplateAction,
  dispatchCreateMappedPdfTemplateAction,
  dispatchResetMasterPdfTemplateList,
}: AppProps) => {
  const [pdfTemplate, setPdfTemplate] = useState<PdfTemplateOptionsType | []>(
    []
  );
  const [pdfTemplateModalSelected, setPdfTemplateModalSelected] = useState("");
  const [defaultPdfId, setDefaultPdfId] = useState<string | null>(null);
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id }: any = useParams();

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetClientSettingMessage();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetMappedPdfTemplateAction();
    dispatchResetMasterPdfTemplateList();
    setPdfTemplate([]);
    toast.dismiss();
    setDefaultPdfId(null);
    if (token) {
      let finalData = {
        token,
        invoiceType: "revenues",
        // clientCode: id,
      };
      dispatchGetMasterPdfTemplateAction(finalData);

      let mappedFinalData = {
        token,
        clientCode: id,
        invoiceType: "revenues"
      };
      dispatchGetMappedPdfTemplateAction(mappedFinalData);
    }
    return () => {
      toast.dismiss();
      dispatchResetMasterPdfTemplateList();
      setPdfTemplate([])
    };
  }, []);



  const handleChangeSequence = (pdfTemplate: PdfTemplateOptionsType | [], id: string) => {
    for (let i = 0; i < pdfTemplate?.length; i++) {
      if (pdfTemplate[i]?.id == +id && i > 0) {
        swapValues(pdfTemplate, 0, i);
      } else {
        continue;
      }
    }
    setPdfTemplate([...pdfTemplate]);
  };

  const swapValues = (
    arr: PdfTemplateOptionsType | [],
    left: number,
    right: number
  ) => {
    let temp = arr[left];
    arr[left] = arr[right];
    arr[right] = temp;
  };

  useEffect(() => {
    if (
      success === 1 &&
      message?.includes("has been mapped with client successfully!")
    ) {
      setIsButtonDisable(true)
      toast.success("Invoice Template Assigned Successfully!", {
        duration: 3000,
      });
      dispatchResetMasterSuccess();
      dispatchResetMasterError();
      dispatchResetClientSettingMessage();
      dispatchResetMasterMessage();
      dispatchResetMasterStatusCode();
      dispatchResetClientSettingsSuccess();
      dispatchResetClientSettingsError();
      let mappedFinalData = {
        token,
        clientCode: id,
        invoiceType: "revenues"
      };
      dispatchGetMappedPdfTemplateAction(mappedFinalData);
    }
  }, [success, message]);

  useEffect(() => {
    if (pdfTemplateList?.length > 0) {
      const updatedTemplates = pdfTemplateList?.map((template: PdfTemplateType) => {
        const match = mappedPdfTemplate?.find(
          (mapped) => mapped?.pdf_template_id === template?.pdf_template_id
        );

        const isChecked = !!match;
        const newItem = {
          id: template?.pdf_template_id,
          name: template?.pdf_template_name,
          isChecked,
        };

        // Call handleChangeSequence only once (after loop)
        if (match?.is_default) {
          const defaultId = template?.pdf_template_id?.toString();
          setDefaultPdfId(defaultId);
          // use setTimeOut so that it runs at last
          setTimeout(() => {
            handleChangeSequence([...updatedTemplates], defaultId);
          }, 0);
        }

        return newItem;
      });
      setPdfTemplate(updatedTemplates);
    }
  }, [mappedPdfTemplate, pdfTemplateList]);



  const handleChangeCheckBox = (index: number) => {
    setIsButtonDisable(false);
    let newData = JSON.parse(JSON.stringify(pdfTemplate));
    newData[index].isChecked = !newData[index]?.isChecked;
    setPdfTemplate([...newData]);
  };

  const getPdfTemplateId = () => {
    let pdfTemplateId: any = [];
    pdfTemplate?.map((singleTemplate: PdfTemplateOptionType) => {
      if (singleTemplate?.isChecked) {
        pdfTemplateId.push(singleTemplate?.id);
      }
    });
    return pdfTemplateId;
  };

  const handleAssignPdf = () => {
    let pdfTemplateId = getPdfTemplateId();

    let finalData = {
      token,
      pdfTemplateId,
      clientCode: id,
      defaultPdfTemplateId: defaultPdfId,
      invoiceType: "revenues",
    };

    dispatchCreateMappedPdfTemplateAction(finalData);
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess()
  };

  const handleDefaultPdfId = (pdfId: string) => {
    setIsButtonDisable(false);
    setDefaultPdfId(pdfId);
  };

  const handleModal = (name?: string) => {
    setPdfTemplateModalSelected(name ? name : "");
    setIsModalOpen((prev: boolean) => !prev);
  };

  const handleErrorModal = () => {
    if (success === 0 || masterSuccess === 0) {
      dispatchResetMasterSuccess();
      if (statusCode === 401 || masterStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode || masterStatusCode}
          />
        );
      } else if (
        (!!error || !!masterError) &&
        (statusCode !== 401 || masterStatusCode !== 401)
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message={error || masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterError();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
              dispatchResetClientSettingsSuccess();
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    return false;
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div style={{ maxWidth: "78%" }}>
          <p className="pdf_template_header">{menuName}</p>
          <p className="sub_heading">
            Please select the check circle to assign the Invoice template to the
            client. Then, click “Submit” to save your changes.
          </p>
        </div>

        <div>
          <button
            className="btn btn-primary"
            disabled={isButtonDisable || !pdfTemplate?.find((item: PdfTemplateOptionType) => item.isChecked)}
            onClick={handleAssignPdf}
          >
            Submit
          </button>
        </div>
      </div>

      {isModalOpen && (
        <GeneralSettingPdfPreviewModal
          modal={isModalOpen}
          pdfTemplateModalSelected={pdfTemplateModalSelected}
          toggleModal={handleModal}
        />
      )}

      <div className="pdfImages mt-3">
        {pdfTemplate?.map(
          (
            singlePdf: {
              name: string;
              isChecked: boolean;
              id: string | number;
            },
            index: number
          ) => {
            return (
              <SinglePdfImage
                singlePdf={singlePdf}
                handleChangeCheckBox={handleChangeCheckBox}
                handleDefaultPdfId={handleDefaultPdfId}
                index={index}
                handleModal={handleModal}
                defaultPdfId={defaultPdfId}
              />
            );
          }
        )}
        <Toaster />
        {fetching && <Loader />}
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  masterStatusCode: state.masterData.statusCode,
  masterError: state.masterData.error,
  masterSuccess: state.masterData.success,
  masterMessage: state.masterData.message,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  message: state.clientSettings.message,
  pdfTemplateList: state.masterData.pdfTemplateList,
  pdfTemplateCount: state.masterData.pdfTemplateCount,
  mappedPdfTemplate: state.clientSettings.mappedPdfTemplate,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetMappedPdfTemplateAction: () =>
    dispatch(resetMappedPdfTemplate()),
  dispatchGetMasterPdfTemplateAction: (data: GetMasterDataListPayloadType) =>
    dispatch(getMasterPdfTemplateListAction(data)),
  dispatchGetMappedPdfTemplateAction: (
    data: GetPdfMappingTemplatePayloadType
  ) => dispatch(getMappedPdfTemplateAction(data)),
  dispatchCreateMappedPdfTemplateAction: (
    data: AddPdfMappingTemplatePayloadType
  ) => dispatch(createMappedPdfTemplateAction(data)),
  dispatchResetMasterPdfTemplateList: () => dispatch(resetPdfTemplate()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfTemplates);
